type Pdfjs = typeof import("pdfjs-dist");

let workerReady = false;

async function ensurePdfWorker(pdfjs: Pdfjs): Promise<void> {
  if (workerReady) return;
  try {
    const WorkerFactory = (await import("pdfjs-dist/build/pdf.worker.min.mjs?worker&inline")).default;
    pdfjs.GlobalWorkerOptions.workerPort = new WorkerFactory();
    workerReady = true;
    return;
  } catch {
    /* Fall through to a URL-based worker, then a same-thread fake worker. */
  }
  try {
    const worker = await import("pdfjs-dist/build/pdf.worker.min.mjs?url");
    pdfjs.GlobalWorkerOptions.workerSrc = worker.default;
    workerReady = true;
  } catch {
    pdfjs.GlobalWorkerOptions.workerSrc = "";
  }
}

export async function loadPdfDocument(bytes: Uint8Array) {
  const pdfjs = await import("pdfjs-dist");
  await ensurePdfWorker(pdfjs);
  const copy = new Uint8Array(bytes.byteLength);
  copy.set(bytes);
  return pdfjs.getDocument({
    data: copy,
    disableRange: true,
    disableStream: true,
    disableAutoFetch: true,
    isEvalSupported: false,
    useWorkerFetch: false,
  }).promise;
}

export async function renderPdfToHost(host: HTMLElement, bytes: Uint8Array): Promise<void> {
  const pdf = await loadPdfDocument(bytes);
  host.replaceChildren();
  const cssWidth = Math.max(host.clientWidth || 0, 280);
  const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);

  for (let pageNo = 1; pageNo <= pdf.numPages; pageNo++) {
    const page = await pdf.getPage(pageNo);
    const base = page.getViewport({ scale: 1 });
    const scale = cssWidth / base.width;
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    canvas.className = "docs-pdf-page";
    canvas.width = Math.max(1, Math.floor(viewport.width * pixelRatio));
    canvas.height = Math.max(1, Math.floor(viewport.height * pixelRatio));
    canvas.style.width = `${Math.floor(viewport.width)}px`;
    canvas.style.height = `${Math.floor(viewport.height)}px`;
    const ctx = canvas.getContext("2d");
    if (!ctx) continue;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    await page.render({ canvasContext: ctx, viewport }).promise;
    host.appendChild(canvas);
  }
}
